import { render, staticRenderFns } from "./AddFabric.vue?vue&type=template&id=076dd5aa&scoped=true&"
import script from "./AddFabric.vue?vue&type=script&lang=js&"
export * from "./AddFabric.vue?vue&type=script&lang=js&"
import style0 from "./AddFabric.vue?vue&type=style&index=0&id=076dd5aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076dd5aa",
  null
  
)

export default component.exports